import axios from "axios";
import { tokenManager } from "utils/tokenManager";

const KPI_API_BASE = "https://usibras-web-backend.onrender.com/api";

/**
 * Fetch all sectors from the backend.
 *
 * @returns {Promise<{ data: Array, message: string }>}
 */
export async function getSectors() {
  const authHeader = tokenManager.getAuthHeader();
  const headers = {};
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  const response = await axios.get(`${KPI_API_BASE}/sectors`, { headers });
  return response.data;
}

/**
 * Create a new sector.
 *
 * @param {Object} data
 * @param {string} data.name - Sector name
 * @param {string} [data.description] - Sector description
 * @param {string} [data.iconKey] - Icon key (e.g. warehouse, steam, build)
 * @returns {Promise<{ data: Object, message: string }>}
 */
/**
 * Update an existing sector.
 *
 * @param {number|string} sectorId - Sector ID
 * @param {Object} data
 * @param {string} data.name - Sector name
 * @param {string} [data.description] - Sector description
 * @param {string} [data.iconKey] - Icon key
 * @returns {Promise<{ data: Object, message: string }>}
 */
export async function updateSector(sectorId, data) {
  const authHeader = tokenManager.getAuthHeader();
  const headers = { "Content-Type": "application/json" };
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  const response = await axios.put(
    `${KPI_API_BASE}/sectors/${sectorId}`,
    {
      name: data.name?.trim() || "",
      description: data.description?.trim() || "",
      icon_key: data.iconKey || "warehouse",
    },
    { headers }
  );
  return response.data;
}

/**
 * Delete a sector.
 *
 * @param {number|string} sectorId - Sector ID
 * @returns {Promise<{ id: number, message: string }>}
 */
export async function deleteSector(sectorId) {
  const authHeader = tokenManager.getAuthHeader();
  const headers = {};
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  const response = await axios.delete(`${KPI_API_BASE}/sectors/${sectorId}`, { headers });
  return response.data;
}

export async function createSector(data) {
  const authHeader = tokenManager.getAuthHeader();
  const headers = {};
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  const response = await axios.post(
    `${KPI_API_BASE}/sectors`,
    {
      name: data.name?.trim() || "",
      description: data.description?.trim() || "",
      icon_key: data.iconKey || "warehouse",
    },
    { headers }
  );
  return response.data;
}
